import React from "react";
import { Box, Typography } from "@mui/material";
import slide3 from '../../../assets/Images/slide3.jpg';
import logo from '../../../assets/Images/logo_ft.png'
const Header = () => {
    return (
        <div>
            <Box
                sx={{
                    backgroundColor:"#1976d2",
                    backgroundPosition: "center center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    height: "76px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "white",
                    textAlign: "center",

                }}
            >
                <Typography variant="h5" sx={{ display: "flex", flexDirection: "row", marginTop: "3px", fontWeight: "600" }}>
                    <img style={{ height: "40px", marginLeft: "5px" }} src={logo} />
                </Typography>
                <Typography variant="h6" sx={{ fontSize: "14px" }}>
                    Cloud-Hosted Digital Document and Record Management System (DDRMS)
                </Typography>
            </Box>
        </div>
    );
};

export default Header;
